import { render, staticRenderFns } from "./SendDetailsPrototype.vue?vue&type=template&id=68f486c4&scoped=true&"
import script from "./SendDetailsPrototype.vue?vue&type=script&lang=js&"
export * from "./SendDetailsPrototype.vue?vue&type=script&lang=js&"
import style0 from "./SendDetailsPrototype.vue?vue&type=style&index=0&id=68f486c4&prod&lang=css&"
import style1 from "./SendDetailsPrototype.vue?vue&type=style&index=1&id=68f486c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f486c4",
  null
  
)

export default component.exports